import React from 'react'

const WorkerApplications = () => {
  return (
    <p className='description'>Этой страницы не существует</p>
  )
}

export default WorkerApplications;